/**
 * Guest track-order page — calls SORA white-label tracking API.
 */
(function () {
  const root = document.getElementById("sora-track-root");
  if (!root) return;

  const form = document.getElementById("sora-track-form");
  const result = document.getElementById("sora-track-result");
  const errEl = document.getElementById("sora-track-error");
  const orderInput = document.getElementById("sora-track-order");
  const emailInput = document.getElementById("sora-track-email");
  const apiBase = (window.SORA_TRACK && window.SORA_TRACK.apiBase) || "";

  const params = new URLSearchParams(window.location.search);
  const preOrder = params.get("order") || params.get("orderNumber");
  if (preOrder && orderInput) {
    orderInput.value = preOrder.startsWith("#") ? preOrder : `#${preOrder}`;
  }

  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.hidden = !msg;
  }

  function formatDate(iso) {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleString("en-GB", {
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return "";
    }
  }

  function renderTimeline(steps) {
    const list = result.querySelector("[data-timeline]");
    if (!list) return;
    list.innerHTML = "";
    (steps || []).forEach((step) => {
      const li = document.createElement("li");
      li.className = "sora-track__step";
      if (step.complete) li.classList.add("is-complete");
      if (step.current) li.classList.add("is-current");
      li.innerHTML = `
        <span class="sora-track__step-dot" aria-hidden="true"></span>
        <div class="sora-track__step-body">
          <strong>${step.label || step.status}</strong>
          ${step.at ? `<span class="sora-track__step-time">${formatDate(step.at)}</span>` : ""}
        </div>`;
      list.appendChild(li);
    });
  }

  function renderItems(items) {
    const ul = result.querySelector("[data-items]");
    if (!ul || !items?.length) return;
    ul.hidden = false;
    ul.innerHTML = items
      .map(
        (it) =>
          `<li>${it.quantity > 1 ? `${it.quantity}× ` : ""}${it.title || "Item"}</li>`
      )
      .join("");
  }

  function renderPayload(data) {
    showError("");
    result.hidden = false;
    result.querySelector("[data-order-name]").textContent =
      data.orderName || "";
    result.querySelector("[data-status-label]").textContent =
      data.statusLabel || "Processing";
    result.querySelector("[data-carrier]").textContent =
      data.carrierMasked || "SORA Delivery";

    const eta = result.querySelector("[data-eta]");
    if (data.estimatedWindow) {
      eta.textContent = data.estimatedWindow;
      eta.hidden = false;
    } else {
      eta.hidden = true;
    }

    const updated = result.querySelector("[data-updated]");
    if (data.lastUpdated) {
      updated.textContent = `Updated ${formatDate(data.lastUpdated)}`;
      updated.hidden = false;
    } else {
      updated.hidden = true;
    }

    renderTimeline(data.timeline);
    renderItems(data.items);
    result.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  async function lookup(orderNumber, email) {
    if (!apiBase) {
      showError("Tracking is temporarily unavailable. Please try again later.");
      return;
    }
    showError("");
    const submit = form.querySelector(".sora-track__submit");
    if (submit) submit.disabled = true;

    try {
      const res = await fetch(`${apiBase.replace(/\/$/, "")}/api/tracking/lookup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderNumber, email }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.ok) {
        const map = {
          order_not_found: "We could not find that order. Check the number and email from your confirmation.",
          email_mismatch: "That email does not match this order. Use the address from checkout.",
          email_required: "Enter the email you used at checkout.",
          order_number_required: "Enter your order number (e.g. #1042).",
        };
        showError(map[data.error] || "Unable to load tracking. Try again in a few minutes.");
        result.hidden = true;
        return;
      }
      renderPayload(data);
    } catch {
      showError("Connection error. Please try again.");
      result.hidden = true;
    } finally {
      if (submit) submit.disabled = false;
    }
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    lookup(orderInput.value.trim(), emailInput.value.trim());
  });

  if (preOrder && emailInput && emailInput.value) {
    lookup(orderInput.value.trim(), emailInput.value.trim());
  }
})();
